import { useEffect, useState } from "react";

import api from "../services/api";
import { useClient } from "./useClient";

/**
 * This cabinet's client as the server sees it now: auth_mode, slug, counts.
 *
 * useClient() only knows what the login carried (id, name, access); pages
 * that word themselves by how people get in (QR or the site's ticket) need
 * the live row. Null until loaded; a failure leaves it null and the page
 * falls back to its neutral wording.
 */
export function useClientInfo() {
  const { clientId } = useClient();
  const [info, setInfo] = useState(null);

  useEffect(() => {
    if (!clientId) return undefined;
    let live = true;
    api
      .get(`/clients/${clientId}/`)
      .then((res) => live && setInfo(res.data))
      .catch(() => {});
    return () => {
      live = false;
    };
  }, [clientId]);

  return info;
}
